/**
 * Предзагрузка чанка сообщений семейства маршрутов по намерению пользователя (KAN-975).
 *
 * Чанк сообщений семейства грузится динамически, поэтому при клиентском переходе в раздел впервые
 * область страницы осталась бы пустой, пока он не придёт. Ссылки меню вызывают `preloadMessagesFor`
 * на наведение, фокус и касание: пока палец или курсор дошли до клика, чанк (десятки КБ) уже в
 * кэше модулей, и переход мгновенный. Лишний вызов безвреден — import() кэширует модуль, а сеть
 * трогается один раз.
 */
type Loader = (locale: string) => Promise<unknown>;

const FAMILIES: Array<{ prefix: string; load: Loader }> = [
  {
    prefix: "/tournaments",
    load: (locale) => (locale === "en" ? import("./families/tournaments-messages-en") : import("./families/tournaments-messages-ru")),
  },
  {
    prefix: "/admin",
    load: (locale) => (locale === "en" ? import("./families/admin-messages-en") : import("./families/admin-messages-ru")),
  },
];

export function preloadMessagesFor(href: string, locale: string = currentLocale()): void {
  const hit = FAMILIES.find((f) => href === f.prefix || href.startsWith(`${f.prefix}/`));
  // Ошибка загрузки не должна ломать меню: при самом переходе chunk запросится снова.
  if (hit) void hit.load(locale).catch(() => {});
}

/** Язык страницы в момент события: <html lang> выставляет корневой лейаут (root-shell). */
function currentLocale(): string {
  return typeof document !== "undefined" && document.documentElement.lang === "en" ? "en" : "ru";
}

/** Свойства ссылки: навесить на `<Link {...messagesIntent(href)}>`. */
export function messagesIntent(href: string) {
  const go = () => preloadMessagesFor(href);
  return { onMouseEnter: go, onFocus: go, onTouchStart: go };
}
